import script from "./DeleteModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteModule.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteModule.vue?vue&type=style&index=0&id=c9437b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9437b4e"]])

export default __exports__